import React from 'react';
import { Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const RefreshButton: React.FC = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleRefresh = () => {
    const searchParams = new URLSearchParams(search);
    searchParams.delete('keyword');
    searchParams.delete('start_date');
    searchParams.delete('end_date');
    searchParams.set('page', '1');
    navigate(`?${searchParams.toString()}`);
  };

  return (
    <Button onClick={handleRefresh} variant='contained'>
      Refresh
    </Button>
  );
};

export default RefreshButton;
